var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CheckboxWithLabel',{on:{"checkboxChange":_vm.checkboxChange}},[_vm._v("\n        "+_vm._s(_vm.TEXTS.render(`PRIVACY_STATEMENT_CHECKBOX`))+"\n    ")]),_vm._v(" "),_c('p',{staticClass:"mb-0",domProps:{"innerHTML":_vm._s(_vm.TEXTS.render(`PRIVACY_STATEMENT_SUBHEADER`, null, null, {skipCasing:true}))}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }